
import axios from 'axios';

class reportFiltersService {

    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL
        }
    }

    getReportFilters() {
        return axios.post(this.state.apiUrl + "analytics/viewReport", null, { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    applyFilters(params) {
        return axios.post(this.state.apiUrl + "analytics/applyFilter", JSON.stringify(params))
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }


}


export default reportFiltersService;